export default "__VITE_ASSET__4273ee68__"